<template>
    <div>
      <div v-if="!isLoad">
        <v-main class="bg-[#F7FAFB] dark-bg-default" style="padding: 0px">
          <v-col>
            <v-tabs v-model="tabs" align-with-title :color="$vuetify.theme.currentTheme.primary">
              <v-tab
                :ripple="false"
                v-for="(tab, index) in visibleTabItems"
                :key="index"
                class="mr-12 ml-0"
                :color="$vuetify.theme.currentTheme.primary"
              >
                {{ tab.name }}
              </v-tab>
              <v-tabs-slider color="#32D583"></v-tabs-slider>
            </v-tabs>
          </v-col>
          <component :is="currentTab" @navToAmcPlan="handlePlanTab"></component>
        </v-main>
      </div>
      <div
        v-else
        class="absolute w-full h-screen flex-col items-center flex justify-center"
      >
        <v-progress-circular
          :color="$vuetify.theme.currentTheme.primary"
          indeterminate
          :size="50"
          :width="5"
        ></v-progress-circular>
        <div class="mt-2"><span>Please Wait...</span></div>
      </div>
    </div>
  </template>
  
  <script>
  // import Overview from "~/components/Workforce/WarrantyManagement/Overview.vue";
  import AmcList from "@/components/Workforce/WarrantyManagement/AmcList.vue";
  import AmcPlans from "@/components/Workforce/WarrantyManagement/AmcPlans.vue";
  import { isModuleFeatureAllowed, hasPermission } from "@/utils/common";
  import permissionData from "@/utils/permissions";
  
  export default {
    name: "WarrantyManagement",
    layout: "Workforce/default",
    components: {
      // Overview,
      AmcList,
      AmcPlans,
    },
    data() {
      return {
        tabs: 0,
        userData: this.$store.state.wfmPermissions,
        isLoad: true,
      };
    },
    computed: {
      canRead() {
        return hasPermission(this.userData, permissionData.amcRead);
      },
      tabItems() {
        return [
          // { key: "Overview", name: "Overview", component: "Overview", visible: this.canRead && this.isFeatureVisible("MANAGE_AMC_OVERVIEW") },
          {
            key: "AmcList",
            name: "AMC List",
            component: "AmcList",
            visible: this.canRead && this.isFeatureVisible("MANAGE_AMC_SELLS"),
          },
          {
            key: "AmcPlans",
            name: "AMC Plans",
            component: "AmcPlans",
            visible: this.canRead && this.isFeatureVisible("MANAGE_AMC_PLANS"),
          },
        ];
      },
      visibleTabItems() {
        return this.tabItems.filter((tab) => tab.visible);
      },
      currentTab() {
        return this.visibleTabItems[this.tabs]?.component;
      },
    },
    mounted() {
      const firstVisibleTabIndex = this.visibleTabItems.findIndex(
        (tab) => tab.visible
      );
  
      if (firstVisibleTabIndex !== -1) {
        this.tabs = firstVisibleTabIndex;
      }
  
      const query = this.$route.query;
      const tabIndexFromQuery = this.visibleTabItems.findIndex(
        (tab) => tab.key === "AmcList"
      );
      if (query.active_tab === "amcList" && tabIndexFromQuery !== -1) {
        this.tabs = tabIndexFromQuery;
      }
  
      this.isLoad = false;
    },
    methods: {
      handlePlanTab() {
        const tabIndex = this.visibleTabItems.findIndex(
          (tab) => tab.key === "AmcPlans"
        );
        if (tabIndex !== -1) {
          this.tabs = tabIndex;
        }
      },
      isFeatureVisible(feature) {
        return isModuleFeatureAllowed("AMC", feature);
      },
    },
  };
  </script>
  
  <style scoped>
  .v-tab:before {
    background-color: transparent;
  }
  
  .v-tab {
    font-size: 16px;
  }
  </style>
  